import { inject, Injectable } from '@angular/core';
import { type Observable, shareReplay } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

import { SiteFacade } from '@web/store/website/site/site.facade';
import { ProductCatalogHttpService } from '@web/store/website/product-catalog/product-catalog.http.service';
import type { EnabledCategoryIds } from '@web/widgets/catalog-products/utils/enabled-categories.util';

@Injectable({
    providedIn: 'root',
})
export class CatalogEnabledCategoriesService {
    private readonly siteFacade = inject(SiteFacade);
    private readonly productCatalogHttpService = inject(ProductCatalogHttpService);

    /**
     * Ids of the product categories enabled for the current site, null when they could not be loaded.
     * Shared between the catalog control and view so that a single widget makes one request.
     *
     * The site id is awaited rather than read once: the store fills it asynchronously, and requesting
     * `landing-sites/undefined` would answer with an error that reads as "nothing is enabled".
     */
    public readonly enabledCategoryIds$: Observable<EnabledCategoryIds> = this.siteFacade.id$.pipe(
        filter(Boolean),
        take(1),
        switchMap((siteId: number) => this.productCatalogHttpService.retrieveLandingProductCategories(siteId)),
        shareReplay({ bufferSize: 1, refCount: true })
    );
}
